import { Stack } from '@mui/material';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';

export function HumanTaskDynamicConfigFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.dynamicConfig"
        label="Dynamic Config"
        helperText="Enter the form template for the dynamic config. Template must have matching braces. e.g. {{blockName.data}}"
      />
    </Stack>
  );
}
